import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './RadioOption.css';
import classnames from "classnames";

export default class RadioOption extends React.Component {

  constructor() {
    super();
    this.inputRef = React.createRef();
  }

  divClick() {
    this.props.onChange();
    this.inputRef.current.focus();
  }

  render() {    
    return (
      <div className={classnames(css['radio'], {[css['selected']]: !!this.props.isChecked }, {[css['error']]: !!this.props.error })} onClick={this.divClick.bind(this)}>
        <div className={css['option-container']}>
          <input
            type="radio"
            id={this.props.id}
            name={this.props.radioName}
            ref={this.inputRef}
            className={css['option-radio']}
            value={this.props.value}
            onChange={this.props.onChange}
            checked={this.props.isChecked}
            aria-label={this.props.ariaLabel ? this.props.ariaLabel : null}
            aria-required={!!this.props.required}
            aria-checked={this.props.isChecked} />
          {this.props.label}
        </div>
      </div>
    );
  }
}

RadioOption.propTypes = {
  value: SFEntityID,
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.object.isRequired,
  radioName: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  id: PropTypes.string
};
